<template>
  <div class="create_notice-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">通知内容</p>
        <div class="nav-right" slot="right">
        </div>
      </yioks-page-nav>
      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
              :model="formData"
              :rules="formRules"
              ref="mainForm"
              label-width="110px"
              size="medium"
              class="form-box yioks-form-box"
            >
              <el-form-item label="标题" prop="title">
                <el-input v-model.trim="formData.title" class placeholder="标题输入请不要超过40个字符"></el-input>
              </el-form-item>
              <el-form-item label="接收用户" prop="user">
                <el-select multiple v-model="formData.user" placeholder="请选择接收用户" class="user_select">
                  <el-option
                    v-for="item in usersList"
                    :key="item.value"
                    :value="isFive ? item.fiveValue : item.value"
                    :label="isFive ? item.fiveKey : item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="内容" prop="content" required>
                <el-input v-show="false" v-model="formData.content" class placeholder></el-input>
                <quill-editor
                  :class="['editor-box', errorClass]"
                  ref="textEditor"
                  v-model="formData.content"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                ></quill-editor>
              </el-form-item>
              <el-form-item label="发送人落款" prop="expediter" class="expediter">
                <el-input v-model.trim="formData.expediter" class placeholder="请输入发送人"></el-input>
              </el-form-item>
              <el-form-item label="强制弹框提醒">
                <el-switch v-model="formData.push"></el-switch>
              </el-form-item>
              <el-form-item label="附件上传">
                <el-upload
                  ref="uploadFile"
                  action="/api/notification/upload_notice_file.json"
                  :limit="3"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress='isUping'
                  :on-error='uploadError'
                  :on-success="uploadSuccess"
                  :on-remove='fileRemove'
                  :on-exceed="fileExceed"
                >
                  <el-button type="primary">上传附件</el-button>
                  <!-- <div slot="tip" class="">ssssssss</div> -->
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="post-btn">
        <el-button type="primary" @click="preview()">预览</el-button>
        <el-button type="primary" :loading="repeatSubmit" :disabled="submitDisabled" @click="submit()">发布</el-button>
        <el-button type="danger" @click="goBack">取消</el-button>
      </div>
    </div>
    <notice-detail-dialog @hideDia="closeDetail" :if-show="ifPreviewDiaShow" :info="previewInfo"></notice-detail-dialog>
    <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="delComfimDia"></yioks-tips>
  </div>
</template>

<script>
import scrollOpt from "@/assets/js/vuescrollOption";
import { storageData } from "@/assets/js/storage";
import { usersList } from "../navData";
import { addNotice } from "@/api/notice/notice";
import { parseUserLevelToAbridge } from "@/assets/js/yioksFilters";
import fiveMixins from '@/minix/fiveMixins';

export default {
  name: "create-notice",
  mixins: [fiveMixins],
  data() {
   
    const formRules = {
      title: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请填写标题"));
            } else {
              if ([...value].length > 40) {
                callback(new Error("标题输入不得超过40个字符"));
              } else {
                callback();
              }
            }
          },
          trigger: "blur"
        }
      ],
      expediter: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请填写发送人"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }
      ],
      user: [{ required: true, message: "请选择接收用户", trigger: "change" }],
      content: [{ required: true, message: "请填写通知内容" }]
    };
    const editorOption = {
      placeholder: '请输入内容',
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "blockquote"],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ color: [] }, { background: [] }],
          [
            { size: ["small", false, "large", "huge"] },
            { header: [1, 2, 3, 4, 5, 6, false] }
          ],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["clean"]
        ]
      }
    };
    return {
      editorOption,
      backComfim: false,
      vuescrollOpt: scrollOpt(),
      formRules,
      formData: {
        title: "",
        expediter: "中国足协技术部",
        user: [],
        content: "",
        push: true,
        files: []
      },
      // usersList: usersData[userInfo.member_type],
      errorClass: "",
      repeatSubmit: false,
      submitDisabled: false,
      fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
      fileUpParam: {},
      ifPreviewDiaShow: false,
      previewInfo: {
        document_list: [],
        notification: {}
      }
    };
  },

  created() {
    if(this.isFive) {
      this.$set(this.formData, 'expediter', '中国足协社会足球部')
    } else {
      this.$set(this.formData, 'expediter', '中国足协技术部')
    }
  },

  methods: {
    delComfimDia(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        this.$router.go(-1);
      }
    },
    preview() {
      const {content, expediter, push, title, files} = this.formData;
      this.previewInfo.notification = {
        create_time: Date.now(),
        expediter,
        title,
        content,
        // push: push ? 1 : 0
      }
      this.previewInfo.document_list = files.map(({document_url, document_name}, i) => ({
        document_name,
        document_address: document_url,
        document_id: i+1
      }))
      this.ifPreviewDiaShow = true;
    },
    closeDetail(ifClose, sure) {
      this.ifPreviewDiaShow = ifClose;
    },
    submit() {
      if (this.repeatSubmit || this.submitDisabled) return;
      this.repeatSubmit = true;
      this.$refs["mainForm"].validate(valid => {
        if (valid) {
          const {title, expediter,user, push, content, files} = this.formData;
          addNotice({
            title: title,
            expediter: expediter,
            user_level: user.join(','),
            push: push ? 1 : 0,
            content: content,
            notification_document: JSON.stringify(files)
          })
            .then(({ data: {status,msg} }) => {
              if (Number(status) === 0) {
                this.repeatSubmit = false;
                this.$router.push({ name: "SendNotice" });
              }else{
                this.repeatSubmit = false;
                this.$message.error(msg);
              }
            })
            .catch(err => {
              this.repeatSubmit = false;
              console.error(err);
            });
        } else {
          this.repeatSubmit = false;
          this.$message.error("请检查所填写的内容是否符合要求");
        }
      });
    },
    onEditorBlur(editor) {
      this.errorClass = this.formData.content ? "suc" : "err";
      this.$refs["mainForm"].validateField("content");
    },
    onEditorFocus(editor) {
      // this.errorClass = true;
    },
    onEditorReady(editor) {
      // console.log("editor ready!");
    },
    goBack() {
      this.backComfim = true;
    },
    beforeUpload(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("文件大小不能超过50M!");
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
    uploadSuccess(res) {
      this.submitDisabled = false
      if (Number(res.status) === 0) {
        this.formData.files.push({document_url: res.result.document_url, document_name: res.result.document_name})
      } else {
        this.$nextTick(() => {});
        this.$message.error(res.msg);
      }
    },
    isUping() {
      this.submitDisabled = true
    },
    uploadError() {
      this.submitDisabled = false
    },
    fileRemove(file, fileList) {
      this.formData.files = fileList
    },
    fileExceed(files, fileList) {
      this.$message.error(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
  },
  computed: {
    myEditor() {
      return this.$refs.textEditor.quill;
    },
    userInfo() {
      const info = storageData.getUserInfo();
      return info;
    },
    usersList() {
       const usersData = {
          sup: [
            {key: '十一人制机构管理员',fiveKey: '五人制机构管理员', value: 'organ', fiveValue: 'orgFive'},
            {key: '十一人制所有讲师',fiveKey: '五人制所有讲师',  value: 'teacher', fiveValue: 'teaFive'},
            { key: "十一人制学员 (培训进行中)", fiveKey: '五人制学员 (培训进行中)', value: "student", fiveValue: 'stuFive' },
            { key: "十一人制所有学员", fiveKey: '五人制所有学员', value: "studentALL", fiveValue: 'stuFiveALL' }
            ],
          sys: [
            {key: '十一人制机构管理员',fiveKey: '五人制机构管理员',  value: 'organ', fiveValue: 'orgFive'},
            {key: '十一人制所有讲师',fiveKey: '五人制所有讲师',  value: 'teacher', fiveValue: 'teaFive'},
            { key: "十一人制学员 (培训进行中)",fiveKey: '五人制学员 (培训进行中)',  value: "student", fiveValue: 'stuFive' },
            { key: "十一人制所有学员", fiveKey: '五人制所有学员', value: "studentALL", fiveValue: 'stuFiveALL' }
            ],
          org: [{ key: "十一人制学员 (培训进行中)",fiveKey: '五人制学员 (培训进行中)',  value: "student", fiveValue: 'stuFive' }],
          tea: [{ key: "十一人制学员 (培训进行中)",fiveKey: '五人制学员 (培训进行中)',  value: "student", fiveValue: 'stuFive' }]
      };
      const abridge = parseUserLevelToAbridge(this.userInfo.member_type) || 'sup'
      return usersData[abridge]
    },
  },
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "notice-detail-dialog": () => import("../DetailDia"),
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '~@/assets/css/mixin';

.create_notice-root {
  zuxie-page-root();

  .main-content-wrap {
    color: $color_white;

    .nav-wrap {
      margin-bottom: 25px;

      .title {
        font-size: $font_size_big;
        line-height: 1;
      }
    }

    .content-wrap {
      position: relative;
      display: block;
      height: 600px;
      margin-bottom: 15px;
      width: 100%;
      padding: 20px 0;
      background-color: $block_bg_color_base;

      .form-box {
        display: block;
        width: 100%;
        padding-right: 30px;
        padding-left: 30px;
        .el-form-item {
          margin-bottom 20px;
          &:last-child {
            margin-bottom 0
          }
        }

        .user_select {
          width:100%;
        }
        .editor-box {
          background-color: $color_white
          color: #333333;
          line-height: 1;
          word-break: break-all;
          word-wrap: break-word;

          &.suc {
            border: 1px solid #67c23a;
          }

          &.err {
            border: 1px solid #f56c6c;
          }
        }
        .expediter{
          width:327px;
        }
      }
    }

    .post-btn {
      display: block;
      text-align: center;
    }
  }
}
</style>

<style lang="stylus">
.create_notice-root {
  .editor-box {
    .ql-container {
      height: 230px;
    }
  }
  .form-box {
    .el-progress__text, .el-upload-list__item-name {
      color #fff
    }
    .el-upload-list__item-name {
      [class^="el-icon"] {
        color #fff
      }
    }
  }
}
</style>


